import {
  useAppLocation,
  useAppNavigate,
  useAppSearch,
} from "_graphql/cache/auth";
import {
  ActionButton,
  CalendarHeader,
  RegularInsurerPicker,
  TableComponent,
} from "components";
import { Action } from "components/buttons/action-button";
import { usePagination } from "hooks";
import { FC } from "react";
import CreateTreatyClaimContainer from "./create";
import { useTreatyClaimShares } from "hooks/data/use-treaty-claims";
import { GetTreatyClaimShares_getTreatyClaimShares } from "_graphql/queries/__generated__/GetTreatyClaimShares";
import numeral from "numeral";
import ViewTreatyClaimShareContainer from "./view";

type Props = {};

const TreatyClaimParticipantsPage: FC<Props> = () => {
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { params } = useAppLocation();
  usePagination();
  const { shares, refetch, loading } = useTreatyClaimShares({
    treatyClaimId: params.claim || "",
  });

  const navigateItem = (id: string) => () => {
    navigate({
      to: `./${id}/payments`,
      search: (old) => ({
        ...old,
        // layers: layers,
        layer: "1",
        // treaty_type: treaty_type,
      }),
    });
  };

  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
      () => {
        navigate({
          search: (old) => ({
            ...old,
            id,
            modal: action,
          }),
        });
      };

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <CalendarHeader />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            loading={loading}
            title={"treaty claims payments"}
            hasSearch
            columns={[
              {
                name: "Reinsurer",
                accessor: "reinsurer",
              },
              {
                name: "Claim Amount (100%)",
                accessor: "claim_paid",
                render: (value: GetTreatyClaimShares_getTreatyClaimShares) => (
                  <div className="flex leading-0">
                    <span>{numeral(value?.claim_paid).format("0,0.00")}</span>
                  </div>
                ),
              },
              {
                name: "Participating %",
                accessor: "percentage",
              },
              {
                name: "Actual Claim Amount",
                accessor: "claim_payment_share",
                render: (value: GetTreatyClaimShares_getTreatyClaimShares) => (
                  <div className="flex leading-0">
                    <span>
                      {numeral(value?.claim_payment_share).format("0,0.00")}
                    </span>
                  </div>
                ),
              },
              // {
              //     name: "Created On",
              //     accessor: "created_at",
              // },
              {
                name: "Actions",
                accessor: "actions",
                render: (value: GetTreatyClaimShares_getTreatyClaimShares) => (
                  <>
                    <ActionButton
                      action={"view"}
                      tooltip="View Claim"
                      onClick={dispatchAction(
                        value?.participant_id || "",
                        "view"
                      )}
                    />
                    <ActionButton
                      action={"expand"}
                      tooltip="View Claim Payments"
                      onClick={navigateItem(value?.participant_id || "")}
                    />
                  </>
                ),
              },
            ]}
            data={shares}
            refetch={refetch}
            renderActions={() => (
              <>
                <RegularInsurerPicker
                  id={"insurer"}
                  label={""}
                  rawId
                  values={{ insurer: searchParams?.insurer }}
                  setFieldValue={(e: any, value: any) => { }}
                  setFieldTouched={() => { }}
                  setFieldError={() => { }}
                />
              </>
            )}
          />
        </div>
      </div>
      <CreateTreatyClaimContainer
        open={searchParams?.modal === "create"}
        setOpen={(val) =>
          navigate({
            search(prev) {
              return {
                ...prev,
                modal: val ? "create" : undefined,
              };
            },
          })
        }
      />

      {searchParams?.modal === "view" && (
        <ViewTreatyClaimShareContainer
          open={searchParams?.modal === "view"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "view" : undefined,
                };
              },
            })
          }
        />
      )}
    </main>
  );
};

export default TreatyClaimParticipantsPage;
